import axios from 'axios'
import Vue from 'vue'

let axiosImage = axios.create({
    baseURL: 'https://apodaca2.rciempaquesplegadizos.com:8181/',
    
    headers: {
        
        'Content-Type': 'application/x-www-form-urlencoded',
       
      },
  })

export async function login (context,data){
    try{
    let url = "api/login"//la direccion de la api
   
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('username',data.username)
    values.append('password',data.password) 

    let response = await Vue.axios({
        method: 'POST',
        url: url,        
        data: values
    })
         
    context.commit('setJWT',response.data)
  
    }catch(error){
        context.commit('loginError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}


export async function imagelogin(context, payload){
    try{
        let url = "api/login" //la direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamos el loading
        let values = new FormData();
        values.append('key', 'RUMwelVSanJ4OG0xdGI1dVpBVFg='); 

        let response = await axiosImage({
            method: 'POST',
            url: url,
            data: values
        });
            
        context.commit('setJWTImage',response.data);
    }catch(error){
        context.commit('loginErrorImage', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function checkjwt(context,payload){
    try{
        const url = "api/checkjwt" //la direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamos el loading
        const values = new FormData();
        values.append('token', payload.token); 

        const response = await axiosImage({
            method: 'POST',
            url: url,
            data: values
        });        
    }catch(error){
       
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}
